import { getFileBlob } from '.'
import jsQR from 'jsqr'

/**
 * @description: base64 to blob
 */
export function dataURLtoBlob(base64Buf: string): Blob {
  const arr = base64Buf.split(',')
  const typeItem = arr[0]
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const mime = typeItem.match(/:(.*?);/)![1]
  const bstr = window.atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}

/**
 * img url to base64
 * @param url
 */
export function imgUrlToBase64(url: string, mineType?: string): Promise<string> {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await getFileBlob(url)
    console.log(res)
    if (res && res.type.indexOf('img')) {
      let canvas = document.createElement('canvas') as Nullable<HTMLCanvasElement>
      const ctx = canvas?.getContext('2d')

      const img = new Image()
      img.crossOrigin = ''
      img.onload = function () {
        if (!canvas || !ctx) {
          reject(new Error('Canvas element or 2D context is not available.'))
          return ''
        }
        canvas.height = img.height
        canvas.width = img.width
        ctx.drawImage(img, 0, 0)
        const dataURL = canvas.toDataURL(mineType || 'image/png')
        canvas = null
        resolve(dataURL)
      }
      img.src = url
    } else {
      reject(new Error('Failed to load image.'))
    }
  })
}

/**
 * img url to blob
 * @param url
 */
export function imgUrlToBlob(url: string): Promise<ImageData> {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const res = await getFileBlob(url)
    if (res && res.type.indexOf('img')) {
      const blobURL = window.URL.createObjectURL(res)

      let canvas = document.createElement('canvas') as Nullable<HTMLCanvasElement>

      const img = new Image()
      // 设置跨域属性为 'anonymous'
      img.crossOrigin = 'anonymous'
      img.onload = function () {
        if (!canvas) {
          reject(new Error('Canvas element is not available.'))
          return ''
        }
        canvas.height = img.height
        canvas.width = img.width
        const ctx = canvas.getContext('2d')
        if (!ctx) {
          reject(new Error('2D context is not available.'))
          return ''
        }
        ctx.drawImage(img, 0, 0, img.width, img.height)
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
        canvas = null
        resolve(imageData)
      }
      img.onerror = () => {
        reject(new Error('Failed to load image.'))
      }
      img.src = blobURL
    } else {
      reject(new Error('Failed to load image.'))
    }
  })
}

/** 解析二维码 */
export async function detectQRCode(url: string): Promise<string> {
  try {
    // 将图片 URL 转换为 Blob 对象
    const blob = await imgUrlToBlob(url)

    // 使用 jsQR 库识别二维码
    const qrCode = jsQR(blob.data, blob.width, blob.height)

    if (qrCode && qrCode.data) {
      return qrCode.data
    }
    return ''
  } catch (error) {
    return ''
  }
}
